// vue
import { ref } from '@vue/composition-api';
import { useStore } from '@/store';

// hooks
import { useAxios } from '@/vue3/hooks/axiosHook';
import { WHSHublinkWhitelabelConfig as WHSHublinkWhitelabelConfigInterface } from '@/vue3/api/models/';

export const useWHSWhitelabelSiteService = () => {
    // hooks
    const { apiUrl } = useStore().state;
    const axios = useAxios();

    // reactive

    // methods
    const getWHSWhitelabelSites = async (): Promise<WHSHublinkWhitelabelConfigInterface[]> => {
        const res = await axios.get(`${apiUrl}/whs-hublink/configs`);
        return res.data;
    };

    const getWHSWhitelabelSiteById = async (id: number): Promise<WHSHublinkWhitelabelConfigInterface> => {
        const res = await axios.get(`${apiUrl}/whs-hublink/config/${id}`);
        return res.data;
    };

    const createWHSWhitelabelSite = async (site_config: WHSHublinkWhitelabelConfigInterface): Promise<any> => {
        const res = await axios.post(`${apiUrl}/whs-hublink/config`, site_config);
        return res.data;
    };

    const uploadWHSWhitelabelSiteLogo = async (image: any, siteId: string): Promise<any> => {
        const res = await axios.post(
            `${apiUrl}/whs-hublink/logo/${siteId}`,
            image,
        );
        return res;
    };

    const updateWHSWhitelabelSite = async (site_config: WHSHublinkWhitelabelConfigInterface): Promise<any> => {
        const res = await axios.put(`${apiUrl}/whs-hublink/config`, site_config);
        return res.data;
    };

    const deleteWHSWhitelabelSite = async (id: number) => {
        const res = await axios.deleteId(`${apiUrl}/whs-hublink/config/${id}`);
        return res.status;
    };

    return {
        getWHSWhitelabelSites,
        getWHSWhitelabelSiteById,
        createWHSWhitelabelSite,
        uploadWHSWhitelabelSiteLogo,
        updateWHSWhitelabelSite,
        deleteWHSWhitelabelSite
    };
};
